// `accountId` is the route identifier: it is never echoed in the request body. The server derives
// `key` from `label`, so there is no field for it either.
class CreateDocumentType {
	constructor(
		public readonly accountId: number,
		public readonly label: string,
	) {
		Object.freeze(this);
	}

	toJSON(): Record<string, unknown> {
		return {
			label: this.label,
		};
	}
}

export default CreateDocumentType;
